import React, { useEffect, useRef } from 'react';
import { useClerk, useSignIn, useSignUp } from '@clerk/react';
import { useNavigate } from 'react-router-dom';

const SSOCallback = () => {
  const clerk = useClerk();
  const { signIn } = useSignIn();
  const { signUp } = useSignUp();
  const navigate = useNavigate();
  const hasRun = useRef(false);

  useEffect(() => {
    (async () => {
      if (!clerk.loaded || hasRun.current) return;
      hasRun.current = true;

      try {
        if (signIn?.status === 'complete') {
          await clerk.setActive({ session: signIn.createdSessionId });
          navigate('/dashboard', { replace: true });
          return;
        }

        if (signUp?.isTransferable) {
          await signIn.create({ transfer: true });
          if (signIn.status === 'complete') {
            await clerk.setActive({ session: signIn.createdSessionId });
            navigate('/dashboard', { replace: true });
            return;
          }
        }

        if (signIn?.isTransferable) {
          await signUp.create({ transfer: true });
          if (signUp.status === 'complete') {
            await clerk.setActive({ session: signUp.createdSessionId });
            navigate('/dashboard', { replace: true });
            return;
          }
        }

        if (signUp?.status === 'complete') {
          await clerk.setActive({ session: signUp.createdSessionId });
          navigate('/dashboard', { replace: true });
          return;
        }

        navigate('/login', { replace: true });
      } catch (err) {
        console.error('SSO callback error:', err);
        navigate('/login', { replace: true });
      }
    })();
  }, [clerk, signIn, signUp, navigate]);

  return (
    <div className="min-h-screen bg-background text-foreground flex items-center justify-center">
      <div className="flex flex-col items-center gap-3">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary border-t-transparent" />
        <p className="text-sm text-muted-foreground">Signing in...</p>
      </div>
    </div>
  );
};

export default SSOCallback;
